import useOutageContactForm from "~/hooks/useOutageContactForm";
import ContactForm from "../ContactForm";
import Button from "../Button";
import PageHeader from "../PageHeader";
import { FC, useEffect } from "react";
import { trackEvent } from "~/helpers/tracking";

interface Props {
  metadata?: {
    headerTitle?: string;
    headerSubtitle?: string;
    headerSubtitleEnabled?: boolean;
  };
}
const OutageContactForm: FC<Props> = ({ metadata = {} }) => {
  const { contactFormProps } = useOutageContactForm();

  const DEFAULT_SUBTITLE =
    "We are currently having technical issues with our website. In the meantime, please fill out this form.";

  useEffect(() => {
    trackEvent({
      action: "elementViewed",
      data: {
        elementType: "Outage Contact Form",
        location: "outage_contact_form",
        position: "address check page",
        text: "outage_contact_form",
      },
    });
  }, []);

  return (
    <>
      <PageHeader
        title={metadata?.headerTitle || "We will be back."}
        subtitle={{
          text: metadata?.headerSubtitleEnabled ? metadata?.headerSubtitle || DEFAULT_SUBTITLE : "",
        }}
        headingLevel={1}
      />
      <ContactForm {...contactFormProps} />
      <Button
        className="accordion__next"
        onClick={contactFormProps?.handleSubmit}
        disabled={!contactFormProps.formValid}
        loading={contactFormProps.loading}
      >
        Submit
      </Button>
    </>
  );
};

OutageContactForm.displayName = "OutageContactForm";

export default OutageContactForm;
